import { render } from "./PaymentsAudit.vue?vue&type=template&id=6e318fa6&ts=true"
import script from "./PaymentsAudit.vue?vue&type=script&lang=ts"
export * from "./PaymentsAudit.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__